module.exports = __webpack_public_path__ + "static/media/LARV-digital-inbjudan.0452ca15.pdf";